import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import { spacing, radius, palette, themeMode, variant } from '../../utils/theme.es.js';
var sizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      padding: spacing("sm")
    },
    md: {
      padding: spacing("lg")
    },
    lg: {
      padding: spacing("xxl")
    }
  }
});
var footerSizeStyles = variant({
  prop: "size",
  variants: {
    sm: {
      paddingTop: spacing("sm")
    },
    md: {
      paddingTop: spacing("lg")
    },
    lg: {
      paddingTop: spacing("lg")
    }
  }
});
var variantStyles = variant({
  prop: "variant",
  variants: {
    solid: {
      color: "text.base",
      border: "1px solid transparent",
      backgroundColor: themeMode({
        light: "neutral.100",
        dark: "neutral.900"
      }),
      '&[role="button"]': {
        '&:hover:not([aria-disabled="true"]), &[aria-selected="true"]': {
          backgroundColor: themeMode({
            light: "neutral.200",
            dark: "neutral.800"
          })
        }
      }
    },
    outline: {
      backgroundColor: "transparent",
      border: "1px solid",
      borderColor: themeMode({
        light: "neutral.200",
        dark: "neutral.700"
      }),
      '&[role="button"]': {
        '&:hover:not([aria-disabled="true"])': {
          backgroundColor: themeMode({
            light: "neutral.100",
            dark: "neutral.800"
          }),
          '&[aria-selected="true"]': {
            backgroundColor: themeMode({
              light: "neutral.200",
              dark: "neutral.700"
            })
          }
        }
      },
      '&[aria-selected="true"]': {
        backgroundColor: themeMode({
          light: "neutral.200",
          dark: "neutral.700"
        })
      }
    }
  }
});
var Header = styled(Box).withConfig({
  componentId: "n1254z-0"
})(["flex:1 1 auto;padding-bottom:", ";"], spacing("sm"));
Header.displayName = "Card.Header";
var Content = styled(Box).withConfig({
  componentId: "n1254z-1"
})(["flex:1 1 auto;"]);
Content.displayName = "Card.Content";
var Footer = styled(Box).withConfig({
  componentId: "n1254z-2"
})(["flex:1 1 auto;"]);
Footer.displayName = "Card.Footer";
var Card = styled(Box).withConfig({
  componentId: "n1254z-3"
})(["display:flex;flex-direction:column;justify-content:center;", ";", ";border-radius:", ";cursor:", ";border-color:", ";&:focus,&:active{outline:none;}&:focus-visible{box-shadow:", " 0px 0px 0px 2px;}&[aria-disabled='true']{cursor:default;pointer-events:none;color:", ";}", "{", "}"], sizeStyles, variantStyles, radius("base"), function (_ref) {
  var onClick = _ref.onClick;
  return onClick && "pointer";
}, function (_ref2) {
  var isError = _ref2.isError;
  return isError && palette("danger.500");
}, themeMode({
  dark: palette("neutral.50"),
  light: palette("neutral.900")
}), themeMode({
  dark: palette("neutral.500"),
  light: palette("neutral.400")
}), Footer, footerSizeStyles);
export { Card, Content, Footer, Header };